(function () {
    'use strict';

    angular.module("imApp").factory("productMoveChoiceService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductMoveChoice: function (parms) {
                return $ihttp.post({
                    method: 2893,
                    parameters: parms || {}
                });
            },
            listMoveTo: function (parms) {
                return $ihttp.post({
                    method: 2894,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2895,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
